import React from 'react';
import { Box } from '@material-ui/core';
import defaultLocales from 'globals/locales/default';
import { Caption, Header, WrapperBox } from './BillingCycle.style-elements';
import BillingSummary from './BillingSummary';
import BillingCycleOptions from './BillingCycleOptions';

const BillingCycle: React.FC = () => {
  return (
    <WrapperBox>
      <Box mb={4}>
        <Caption>{defaultLocales.upgradeYourPlan}</Caption>
      </Box>

      <Box mb={3}>
        <Header>{defaultLocales.billingCycle}</Header>
        <BillingCycleOptions />
      </Box>

      <BillingSummary />
    </WrapperBox>
  );
};

export default BillingCycle;
